import { Capacitor } from '@capacitor/core';

/**
 * Vrai lorsque l'app tourne dans le conteneur natif (iOS / Android via
 * Capacitor), faux sur le web classique.
 *
 * Sert notamment a masquer le parcours d'abonnement Stripe dans les apps
 * mobiles : les regles des stores (Apple 3.1.1, Google Play) imposent l'achat
 * integre pour le contenu numerique paye. Les coachs souscrivent donc depuis le
 * site web ; l'app native n'affiche aucun bouton d'achat externe.
 */
export const isNativeApp = (): boolean => Capacitor.isNativePlatform();
